<template>
  <table-view>
    <template #card-header>
      <h3 class="card-title">Recycle SubResource</h3>
      <div class="row">
        <search-input
          class="ml-auto"
          placeholder="Name, Resource, Building"
          v-model="searchParam"
          @input="fetchAllDeletedSubResource()"
          @change-input="changeSearchVal"
        ></search-input>
      </div>
    </template>
    <template #table-header>
      <th>Sr No.</th>
      <th>Sub Resource Name</th>
      <th>Resource</th>
      <th>Building</th>
      <th>Actions</th>
    </template>
    <template #default>
      <tr
        v-for="(subResource, index) in allDeletedSubResource"
        :key="subResource.sub_resource_id"
      >
        <td>{{ index + 1 }}</td>
        <td>{{ subResource.sub_resource_name }}</td>
        <td>{{ subResource.resource_name }}</td>
        <td>{{ subResource.building_name }}</td>
        <td>{{ subResource.name }}</td>
        <td>
          <span
            @click="recycleHandler(subResource.sub_resource_id)"
            class="show-pointer"
          >
            <i
              class="fa-solid fa-recycle p-2"
              style="color: rgb(12 154 49); font-size: 22px"
              title="Recycle"
            ></i>
          </span>
        </td>
      </tr>
    </template>
  </table-view>
  <custom-pagination
    :prev-page="prevPage"
    :next-page="nextPage"
    :size="pageSize"
    @on-update="paginationDataUpdate"
  />
</template>
<script>
import TableView from "../UI/TableView.vue";
import SearchInput from "../UI/SearchInput.vue";
import CustomPagination from "../shared/pagination/CustomPagination.vue";
import debounce from "lodash.debounce";
export default {
  components: { TableView, SearchInput, CustomPagination },
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      prevPage: false,
      nextPage: false,
      searchParam: "",
      allDeletedSubResource: [],
    };
  },
  methods: {
    changeSearchVal(input) {
      this.searchParam = input;
    },
    paginationDataUpdate(currentPage, pageSize) {
      this.currentPage = currentPage;
      this.pageSize = pageSize;
      this.fetchAllDeletedSubResource();
    },
    fetchAllDeletedSubResource: debounce(function () {
      let searchBody = {
        page: this.currentPage,
        size: this.pageSize,
        searchData: {
          search_str: this.searchParam,
        },
      };

      this.axios
        .post(
          this.$Constants.BaseUrl +
            this.$Constants.ApiEndpoints.FETCH_DELETED_SUBRESOURCE,
          searchBody
        )
        .then((res) => {
          if (res.status === 200) {
            this.allDeletedSubResource = res.data.data;
            this.prevPage = res.data.prevPage;
            this.nextPage = res.data.nextPage;
          } else {
            this.allDeletedSubResource = [];
            this.prevPage = false;
            this.nextPage = false;
          }
        })
        .catch((err) => {
          this.$Methods.toastError(err.response.data.message);
        });
    }, 300),
    recycleHandler(id) {
      this.axios
        .patch(
          this.$Constants.BaseUrl +
            this.$Constants.ApiEndpoints.RESTORE_SUBRESOURCE +
            "/" +
            id
        )
        .then((res) => {
          if (res.status === 200) {
            this.$Methods.toastSuccess(res.data.message);
            this.fetchAllDeletedSubResource();
          }
        })
        .catch((err) => {
          this.$Methods.toastError(err.response.data.message);
        });
    },
  },
  mounted() {
    this.fetchAllDeletedSubResource();
  },
};
</script>
